export function getErrorFromFailedResponse(err) {
    if (err && err.success === false && err.reason) {
      var new_err = new Error(err.reason);
      new_err.status = err.status;
      return new_err;
    }

    return err;
  }
